module.exports = __webpack_public_path__ + "media/images/new/icons/mail-ef4331bdc4b207f0167d4772bf757402.png";